
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/**
 * The current application version
 */
export const VERSION = '11.0.2';
